import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import PortfolioIntroduction from "./sections/PortfolioIntroduction";
import ProjectGallery from "./sections/ProjectGallery";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <HeroBanner />
      <PortfolioIntroduction />
      <ProjectGallery />
      <CallToAction />
      <Footer />
    </div>;
}